import { render, staticRenderFns } from "./LimitQuestion.vue?vue&type=template&id=80dd54a4&scoped=true"
import script from "./LimitQuestion.vue?vue&type=script&lang=js"
export * from "./LimitQuestion.vue?vue&type=script&lang=js"
import style0 from "./LimitQuestion.vue?vue&type=style&index=0&id=80dd54a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80dd54a4",
  null
  
)

export default component.exports